package com.picme

import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.models.Icon.StrokePathData
import com.lightningkite.kiteui.models.Icon.StrokeLineCap
import com.lightningkite.readable.shared

object PIcon {
    val subscription
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M22.7 11.5L20.7005 13.5L18.7 11.5M20.9451 13C20.9814 12.6717 21 12.338 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C14.8273 21 17.35 19.6963 19 17.6573M12 7V12L15 14",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val check
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M20 6L9 17L4 12",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val expand
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M14 10L21 3M21 3H15M21 3V9M10 14L3 21M3 21H9M3 21L3 15",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val brandedAdd
        get() = Icon(
            width = 48.dp,
            height = 48.dp,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                Icon.StrokePathData(
                    strokeWidth = 2.0.dp,
                    strokeLineCap = Icon.StrokeLineCap.Round,
                    path = "M9 2.5H6.5C4.29086 2.5 2.5 4.29086 2.5 6.5V9M15.25 2.5H17.5C19.7091 2.5 21.5 4.29086 21.5 6.5V9M2.5 15V17.5C2.5 19.7091 4.29086 21.5 6.5 21.5H9M21.5 15V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H15"
                ),
                Icon.StrokePathData(
                    strokeWidth = 2.0.dp,
                    strokeLineCap = Icon.StrokeLineCap.Round,
                    path = "M12 8V16M8 12H16"
                )
            )
        )

    val playIcon
        get() = Icon(
            width = 4.rem,
            height = 4.rem,
            viewBoxMinX = 0,
            viewBoxMinY = -960,
            viewBoxWidth = 960,
            viewBoxHeight = 960,
            pathDatas = listOf("m380-300 280-180-280-180v360ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"),
        )

    val camera
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = -960,
            viewBoxWidth = 960,
            viewBoxHeight = 960,
            pathDatas = listOf("M480-260q75 0 127.5-52.5T660-440q0-75-52.5-127.5T480-620q-75 0-127.5 52.5T300-440q0 75 52.5 127.5T480-260Zm0-80q-42 0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33 23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Zm0-80h640v-480H638l-73-80H395l-73 80H160v480Zm320-240Z"),
        )

    val logout
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M16 17L21 12M21 12L16 7M21 12H9M9 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21H9",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val settings
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
                    strokeLineCap = StrokeLineCap.Round
                ), StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val guests
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val addWithCorners
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    strokeLineCap = StrokeLineCap.Round,
                    path = "M9 2.5H6.5C4.29086 2.5 2.5 4.29086 2.5 6.5V9M15.25 2.5H17.5C19.7091 2.5 21.5 4.29086 21.5 6.5V9M2.5 15V17.5C2.5 19.7091 4.29086 21.5 6.5 21.5H9M21.5 15V17.5C21.5 19.7091 19.7091 21.5 17.5 21.5H15"
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    strokeLineCap = StrokeLineCap.Round,
                    path = "M12 8V16M8 12H16"
                )
            )
        )

    val download
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val filterfunnelon
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z",
                    strokeLineCap = StrokeLineCap.Round
                ), StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z",
                    strokeLineCap = StrokeLineCap.Round,
                    fill = Color.darkPurple
                )
            ),
        )

    val image
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M4.27209 20.7279L10.8686 14.1314C11.2646 13.7354 11.4627 13.5373 11.691 13.4632C11.8918 13.3979 12.1082 13.3979 12.309 13.4632C12.5373 13.5373 12.7354 13.7354 13.1314 14.1314L19.6839 20.6839M14 15L16.8686 12.1314C17.2646 11.7354 17.4627 11.5373 17.691 11.4632C17.8918 11.3979 18.1082 11.3979 18.309 11.4632C18.5373 11.5373 18.7354 11.7354 19.1314 12.1314L22 15M10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9ZM6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3H6.8C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val folder
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 18,
            viewBoxHeight = 18,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M9.75 5.25L8.91334 3.57669C8.67255 3.0951 8.55215 2.8543 8.37253 2.67837C8.21368 2.5228 8.02224 2.40448 7.81206 2.33198C7.57437 2.25 7.30516 2.25 6.76672 2.25H3.9C3.05992 2.25 2.63988 2.25 2.31901 2.41349C2.03677 2.5573 1.8073 2.78677 1.66349 3.06901C1.5 3.38988 1.5 3.80992 1.5 4.65V5.25M1.5 5.25H12.9C14.1601 5.25 14.7902 5.25 15.2715 5.49524C15.6948 5.71095 16.039 6.05516 16.2548 6.47852C16.5 6.95982 16.5 7.58988 16.5 8.85V12.15C16.5 13.4101 16.5 14.0402 16.2548 14.5215C16.039 14.9448 15.6948 15.289 15.2715 15.5048C14.7902 15.75 14.1601 15.75 12.9 15.75H5.1C3.83988 15.75 3.20982 15.75 2.72852 15.5048C2.30516 15.289 1.96095 14.9448 1.74524 14.5215C1.5 14.0402 1.5 13.4101 1.5 12.15V5.25Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val save
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M7 3V6.4C7 6.96005 7 7.24008 7.10899 7.45399C7.20487 7.64215 7.35785 7.79513 7.54601 7.89101C7.75992 8 8.03995 8 8.6 8H15.4C15.9601 8 16.2401 8 16.454 7.89101C16.6422 7.79513 16.7951 7.64215 16.891 7.45399C17 7.24008 17 6.96005 17 6.4V4M17 21V14.6C17 14.0399 17 13.7599 16.891 13.546C16.7951 13.3578 16.6422 13.2049 16.454 13.109C16.2401 13 15.9601 13 15.4 13H8.6C8.03995 13 7.75992 13 7.54601 13.109C7.35785 13.2049 7.20487 13.3578 7.10899 13.546C7 13.7599 7 14.0399 7 14.6V21M21 9.32548V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H14.6745C15.1637 3 15.4083 3 15.6385 3.05526C15.8425 3.10425 16.0376 3.18506 16.2166 3.29472C16.4184 3.4184 16.5914 3.59135 16.9373 3.93726L20.0627 7.06274C20.4086 7.40865 20.5816 7.5816 20.7053 7.78343C20.8149 7.96237 20.8957 8.15746 20.9447 8.36154C21 8.59171 21 8.8363 21 9.32548Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val deletetrash
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val back
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M15 18L9 12L15 6",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val info
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val viewtrash
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            pathDatas = listOf(
                "M11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21C13.7631 21 15.8415 20.2086 17.4733 18.8875L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.8875 17.4733C20.2086 15.8415 21 13.7631 21 11.5C21 6.25329 16.7467 2 11.5 2ZM4 11.5C4 7.35786 7.35786 4 11.5 4C15.6421 4 19 7.35786 19 11.5C19 15.6421 15.6421 19 11.5 19C7.35786 19 4 15.6421 4 11.5Z"
            ),
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M10.3333 7H12.6667M8 9.33333H15M14.2222 9.33333L13.9495 14.0086C13.9086 14.71 13.8881 15.0607 13.7556 15.3267C13.6389 15.5608 13.4628 15.749 13.2506 15.8665C13.0097 16 12.7021 16 12.087 16H10.913C10.2979 16 9.99035 16 9.74935 15.8665C9.53718 15.749 9.36115 15.5608 9.24444 15.3267C9.11188 15.0607 9.09142 14.71 9.0505 14.0086L8.77778 9.33333",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val chevronright
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.5.dp,
                    path = "M8.25 19.5L15.75 12L8.25 4.5",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val upload
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 8L12 3M12 3L7 8M12 3V15",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val select
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M7.5 12L10.5 15L16.5 9M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val trash
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M9 3H15M3 6H21M19 6L18.2987 16.5193C18.1935 18.0975 18.1409 18.8867 17.8 19.485C17.4999 20.0118 17.0472 20.4353 16.5017 20.6997C15.882 21 15.0911 21 13.5093 21H10.4907C8.90891 21 8.11803 21 7.49834 20.6997C6.95276 20.4353 6.50009 20.0118 6.19998 19.485C5.85911 18.8867 5.8065 18.0975 5.70129 16.5193L5 6M10 10.5V15.5M14 10.5V15.5",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val copy
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M5 15C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12V5.2C2 4.0799 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2H12C12.9319 2 13.3978 2 13.7654 2.15224C14.2554 2.35523 14.6448 2.74458 14.8478 3.23463C15 3.60218 15 4.06812 15 5M12.2 22H18.8C19.9201 22 20.4802 22 20.908 21.782C21.2843 21.5903 21.5903 21.2843 21.782 20.908C22 20.4802 22 19.9201 22 18.8V12.2C22 11.0799 22 10.5198 21.782 10.092C21.5903 9.71569 21.2843 9.40973 20.908 9.21799C20.4802 9 19.9201 9 18.8 9H12.2C11.0799 9 10.5198 9 10.092 9.21799C9.71569 9.40973 9.40973 9.71569 9.21799 10.092C9 10.5198 9 11.0799 9 12.2V18.8C9 19.9201 9 20.4802 9.21799 20.908C9.40973 21.2843 9.71569 21.5903 10.092 21.782C10.5198 22 11.0799 22 12.2 22Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val qrcode
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M7 12H12V17M3.01 12H3M8.01 17H8M12.01 21H12M21.01 12H21M3 17H4.5M15.5 12H17.5M3 21H8M12 2V8M17.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V17.6C21 17.0399 21 16.7599 20.891 16.546C20.7951 16.3578 20.6422 16.2049 20.454 16.109C20.2401 16 19.9601 16 19.4 16H17.6C17.0399 16 16.7599 16 16.546 16.109C16.3578 16.2049 16.2049 16.3578 16.109 16.546C16 16.7599 16 17.0399 16 17.6V19.4C16 19.9601 16 20.2401 16.109 20.454C16.2049 20.6422 16.3578 20.7951 16.546 20.891C16.7599 21 17.0399 21 17.6 21ZM17.6 8H19.4C19.9601 8 20.2401 8 20.454 7.89101C20.6422 7.79513 20.7951 7.64215 20.891 7.45399C21 7.24008 21 6.96005 21 6.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H17.6C17.0399 3 16.7599 3 16.546 3.10899C16.3578 3.20487 16.2049 3.35785 16.109 3.54601C16 3.75992 16 4.03995 16 4.6V6.4C16 6.96005 16 7.24008 16.109 7.45399C16.2049 7.64215 16.3578 7.79513 16.546 7.89101C16.7599 8 17.0399 8 17.6 8ZM4.6 8H6.4C6.96005 8 7.24008 8 7.45399 7.89101C7.64215 7.79513 7.79513 7.64215 7.89101 7.45399C8 7.24008 8 6.96005 8 6.4V4.6C8 4.03995 8 3.75992 7.89101 3.54601C7.79513 3.35785 7.64215 3.20487 7.45399 3.10899C7.24008 3 6.96005 3 6.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V6.4C3 6.96005 3 7.24008 3.10899 7.45399C3.20487 7.64215 3.35785 7.79513 3.54601 7.89101C3.75992 8 4.03995 8 4.6 8Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val more
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
            ),
        )

    val account
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val radioButtonChecked
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = -960,
            viewBoxWidth = 960,
            viewBoxHeight = 960,
            pathDatas = listOf("M480-280q83 0 141.5-58.5T680-480q0-83-58.5-141.5T480-680q-83 0-141.5 58.5T280-480q0 83 58.5 141.5T480-280Zm0 200q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"),
        )

    val radioButtonUnchecked
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = -960,
            viewBoxWidth = 960,
            viewBoxHeight = 960,
            pathDatas = listOf("M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"),
        )

    val picmeqr
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 36,
            viewBoxHeight = 36,
            pathDatas = listOf(
                "M2.36842 12.3158H0V7.57895C0 3.39321 3.39321 0 7.57895 0H12.3158V2.36842H7.57895C4.70125 2.36842 2.36842 4.70125 2.36842 7.57895V12.3158Z",
                "M23.6842 2.36842V0H28.4211C32.6068 0 36 3.39321 36 7.57895V12.3158H33.6316V7.57895C33.6316 4.70125 31.2987 2.36842 28.4211 2.36842L23.6842 2.36842Z",
                "M36 23.6842H33.6316V28.4211C33.6316 31.2987 31.2987 33.6316 28.4211 33.6316H23.6842V36H28.4211C32.6068 36 36 32.6068 36 28.4211V23.6842Z",
                "M12.3158 33.6316V36H7.57895C3.39321 36 0 32.6068 0 28.4211V23.6842H2.36842L2.36842 28.4211C2.36842 31.2987 4.70125 33.6316 7.57895 33.6316H12.3158Z"
            ),
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M13 18H18V23M9.01 18H9M14.01 23H14M18.01 27H18M27.01 18H27M9 23H10.5M21.5 18H23.5M9 27H14M18 8V14M23.6 27H25.4C25.9601 27 26.2401 27 26.454 26.891C26.6422 26.7951 26.7951 26.6422 26.891 26.454C27 26.2401 27 25.9601 27 25.4V23.6C27 23.0399 27 22.7599 26.891 22.546C26.7951 22.3578 26.6422 22.2049 26.454 22.109C26.2401 22 25.9601 22 25.4 22H23.6C23.0399 22 22.7599 22 22.546 22.109C22.3578 22.2049 22.2049 22.3578 22.109 22.546C22 22.7599 22 23.0399 22 23.6V25.4C22 25.9601 22 26.2401 22.109 26.454C22.2049 26.6422 22.3578 26.7951 22.546 26.891C22.7599 27 23.0399 27 23.6 27ZM23.6 14H25.4C25.9601 14 26.2401 14 26.454 13.891C26.6422 13.7951 26.7951 13.6422 26.891 13.454C27 13.2401 27 12.9601 27 12.4V10.6C27 10.0399 27 9.75992 26.891 9.54601C26.7951 9.35785 26.6422 9.20487 26.454 9.10899C26.2401 9 25.9601 9 25.4 9H23.6C23.0399 9 22.7599 9 22.546 9.10899C22.3578 9.20487 22.2049 9.35785 22.109 9.54601C22 9.75992 22 10.0399 22 10.6V12.4C22 12.9601 22 13.2401 22.109 13.454C22.2049 13.6422 22.3578 13.7951 22.546 13.891C22.7599 14 23.0399 14 23.6 14ZM10.6 14H12.4C12.9601 14 13.2401 14 13.454 13.891C13.6422 13.7951 13.7951 13.6422 13.891 13.454C14 13.2401 14 12.9601 14 12.4V10.6C14 10.0399 14 9.75992 13.891 9.54601C13.7951 9.35785 13.6422 9.20487 13.454 9.10899C13.2401 9 12.9601 9 12.4 9H10.6C10.0399 9 9.75992 9 9.54601 9.10899C9.35785 9.20487 9.20487 9.35785 9.10899 9.54601C9 9.75992 9 10.0399 9 10.6V12.4C9 12.9601 9 13.2401 9.10899 13.454C9.20487 13.6422 9.35785 13.7951 9.54601 13.891C9.75992 14 10.0399 14 10.6 14Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val selectall
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M6 15L8 17L12.5 12.5",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M8.07089 8C8.55612 4.60771 11.4735 2 15 2C18.866 2 22 5.13401 22 9C22 12.5265 19.3923 15.4439 16 15.9291"
                )
            ),
        )

    val add
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 5V19M5 12H19",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val search
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val eyeoff
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M10.7429 5.09232C11.1494 5.03223 11.5686 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7767C21.8518 11.9016 21.8517 12.0987 21.8231 12.2236C21.7849 12.3899 21.7164 12.4985 21.5792 12.7156C21.2793 13.1901 20.8222 13.8571 20.2165 14.5805M6.72432 6.71504C4.56225 8.1817 3.09445 10.2194 2.42111 11.2853C2.28428 11.5019 2.21587 11.6102 2.17774 11.7765C2.1491 11.9014 2.14909 12.0984 2.17771 12.2234C2.21583 12.3897 2.28393 12.4975 2.42013 12.7132C3.54554 14.4952 6.89541 19 12.0004 19C14.0588 19 15.8319 18.2676 17.2888 17.2766M3.00042 3L21.0004 21M9.8791 9.87868C9.3362 10.4216 9.00042 11.1716 9.00042 12C9.00042 13.6569 10.3436 15 12.0004 15C12.8288 15 13.5788 14.6642 14.1217 14.1213",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val calendar
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val unlink
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M9 4V2M15 20V22M4 9H2M20 15H22M4.91421 4.91421L3.5 3.5M19.0858 19.0858L20.5 20.5M12 17.6569L9.87868 19.7782C8.31658 21.3403 5.78392 21.3403 4.22183 19.7782C2.65973 18.2161 2.65973 15.6834 4.22183 14.1213L6.34315 12M17.6569 12L19.7782 9.87868C21.3403 8.31658 21.3403 5.78392 19.7782 4.22183C18.2161 2.65973 15.6834 2.65973 14.1213 4.22183L12 6.34315",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val contract
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M4 14H10M10 14V20M10 14L3 21M20 10H14M14 10V4M14 10L21 3",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val refresh
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M20.453 12.8932C20.1752 15.5031 18.6964 17.9488 16.2494 19.3616C12.1839 21.7088 6.98539 20.3158 4.63818 16.2503L4.38818 15.8173M3.54613 11.1071C3.82393 8.49723 5.30272 6.05151 7.74971 4.63874C11.8152 2.29153 17.0137 3.68447 19.3609 7.74995L19.6109 8.18297M3.49316 18.0662L4.22521 15.3341L6.95727 16.0662M17.0424 7.93413L19.7744 8.66618L20.5065 5.93413",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val share
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59167 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40807 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.163C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val caption
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val chevronleft
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.5.dp,
                    path = "M15.75 19.5L8.25 12L15.75 4.5",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val forward
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M5 12H19M19 12L12 5M19 12L12 19",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val addcircle
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val picme
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 36,
            viewBoxHeight = 36,
            pathDatas = listOf(
                "M10.7739 18.8089H9.31867C9.19851 18.8089 9.11841 18.7275 9.11841 18.6054V9.78746C9.11841 9.66537 9.19851 9.58397 9.31867 9.58397H10.6404C10.7605 9.58397 10.8406 9.66537 10.8406 9.78746L10.8673 10.52C11.3079 9.82816 12.0022 9.42118 13.0035 9.42118C14.8325 9.42118 16.1008 10.9406 16.1008 12.9076C16.1008 14.8883 14.8325 16.3941 13.0035 16.3941C12.109 16.3941 11.4281 16.0414 10.9742 15.4445V18.6054C10.9742 18.7275 10.894 18.8089 10.7739 18.8089ZM12.6163 11.1305C11.6283 11.1305 10.9475 11.8359 10.9475 12.9076C10.9475 13.9794 11.6283 14.6848 12.6163 14.6848C13.5775 14.6848 14.2985 13.9794 14.2985 12.9076C14.2985 11.8495 13.5775 11.1305 12.6163 11.1305Z",
                "M10.7739 18.8089H9.31867C9.19851 18.8089 9.11841 18.7275 9.11841 18.6054V9.78746C9.11841 9.66537 9.19851 9.58397 9.31867 9.58397H10.6404C10.7605 9.58397 10.8406 9.66537 10.8406 9.78746L10.8673 10.52C11.3079 9.82816 12.0022 9.42118 13.0035 9.42118C14.8325 9.42118 16.1008 10.9406 16.1008 12.9076C16.1008 14.8883 14.8325 16.3941 13.0035 16.3941C12.109 16.3941 11.4281 16.0414 10.9742 15.4445V18.6054C10.9742 18.7275 10.894 18.8089 10.7739 18.8089ZM12.6163 11.1305C11.6283 11.1305 10.9475 11.8359 10.9475 12.9076C10.9475 13.9794 11.6283 14.6848 12.6163 14.6848C13.5775 14.6848 14.2985 13.9794 14.2985 12.9076C14.2985 11.8495 13.5775 11.1305 12.6163 11.1305Z",
                "M10.7739 18.8089H9.31867C9.19851 18.8089 9.11841 18.7275 9.11841 18.6054V9.78746C9.11841 9.66537 9.19851 9.58397 9.31867 9.58397H10.6404C10.7605 9.58397 10.8406 9.66537 10.8406 9.78746L10.8673 10.52C11.3079 9.82816 12.0022 9.42118 13.0035 9.42118C14.8325 9.42118 16.1008 10.9406 16.1008 12.9076C16.1008 14.8883 14.8325 16.3941 13.0035 16.3941C12.109 16.3941 11.4281 16.0414 10.9742 15.4445V18.6054C10.9742 18.7275 10.894 18.8089 10.7739 18.8089ZM12.6163 11.1305C11.6283 11.1305 10.9475 11.8359 10.9475 12.9076C10.9475 13.9794 11.6283 14.6848 12.6163 14.6848C13.5775 14.6848 14.2985 13.9794 14.2985 12.9076C14.2985 11.8495 13.5775 11.1305 12.6163 11.1305Z",
                "M19.5879 7.35914C19.5879 7.94248 19.1606 8.40373 18.5732 8.40373C17.9858 8.40373 17.5452 7.94248 17.5452 7.35914C17.5452 6.78937 17.9858 6.32812 18.5732 6.32812C19.1606 6.32812 19.5879 6.78937 19.5879 7.35914Z",
                "M19.5879 7.35914C19.5879 7.94248 19.1606 8.40373 18.5732 8.40373C17.9858 8.40373 17.5452 7.94248 17.5452 7.35914C17.5452 6.78937 17.9858 6.32812 18.5732 6.32812C19.1606 6.32812 19.5879 6.78937 19.5879 7.35914Z",
                "M19.5879 7.35914C19.5879 7.94248 19.1606 8.40373 18.5732 8.40373C17.9858 8.40373 17.5452 7.94248 17.5452 7.35914C17.5452 6.78937 17.9858 6.32812 18.5732 6.32812C19.1606 6.32812 19.5879 6.78937 19.5879 7.35914Z",
                "M17.8389 16.2313C17.7188 16.2313 17.6387 16.1499 17.6387 16.0278V9.78746C17.6387 9.66537 17.7188 9.58397 17.8389 9.58397H19.2941C19.4143 9.58397 19.4944 9.66537 19.4944 9.78746V16.0278C19.4944 16.1499 19.4143 16.2313 19.2941 16.2313H17.8389Z",
                "M17.8389 16.2313C17.7188 16.2313 17.6387 16.1499 17.6387 16.0278V9.78746C17.6387 9.66537 17.7188 9.58397 17.8389 9.58397H19.2941C19.4143 9.58397 19.4944 9.66537 19.4944 9.78746V16.0278C19.4944 16.1499 19.4143 16.2313 19.2941 16.2313H17.8389Z",
                "M17.8389 16.2313C17.7188 16.2313 17.6387 16.1499 17.6387 16.0278V9.78746C17.6387 9.66537 17.7188 9.58397 17.8389 9.58397H19.2941C19.4143 9.58397 19.4944 9.66537 19.4944 9.78746V16.0278C19.4944 16.1499 19.4143 16.2313 19.2941 16.2313H17.8389Z",
                "M26.9944 15.2003C26.4336 15.9329 25.5391 16.3941 24.4844 16.3941C22.4952 16.3941 21.0266 14.8747 21.0266 12.8805C21.0266 10.9134 22.4818 9.42118 24.4444 9.42118C25.5258 9.42118 26.4203 9.88242 26.981 10.615C27.0611 10.71 27.0344 10.8185 26.9543 10.8999L26.1533 11.7003C26.0465 11.8088 25.8996 11.7952 25.8061 11.7003C25.4457 11.334 25.0585 11.1441 24.5245 11.1441C23.4831 11.1441 22.8022 11.9038 22.8022 12.8805C22.8022 13.8573 23.4831 14.6712 24.5645 14.6712C25.0719 14.6712 25.459 14.4813 25.8195 14.115C25.913 14.0201 26.0598 14.0065 26.1666 14.115L26.9677 14.9154C27.0478 14.9968 27.0745 15.1053 26.9944 15.2003Z",
                "M26.9944 15.2003C26.4336 15.9329 25.5391 16.3941 24.4844 16.3941C22.4952 16.3941 21.0266 14.8747 21.0266 12.8805C21.0266 10.9134 22.4818 9.42118 24.4444 9.42118C25.5258 9.42118 26.4203 9.88242 26.981 10.615C27.0611 10.71 27.0344 10.8185 26.9543 10.8999L26.1533 11.7003C26.0465 11.8088 25.8996 11.7952 25.8061 11.7003C25.4457 11.334 25.0585 11.1441 24.5245 11.1441C23.4831 11.1441 22.8022 11.9038 22.8022 12.8805C22.8022 13.8573 23.4831 14.6712 24.5645 14.6712C25.0719 14.6712 25.459 14.4813 25.8195 14.115C25.913 14.0201 26.0598 14.0065 26.1666 14.115L26.9677 14.9154C27.0478 14.9968 27.0745 15.1053 26.9944 15.2003Z",
                "M26.9944 15.2003C26.4336 15.9329 25.5391 16.3941 24.4844 16.3941C22.4952 16.3941 21.0266 14.8747 21.0266 12.8805C21.0266 10.9134 22.4818 9.42118 24.4444 9.42118C25.5258 9.42118 26.4203 9.88242 26.981 10.615C27.0611 10.71 27.0344 10.8185 26.9543 10.8999L26.1533 11.7003C26.0465 11.8088 25.8996 11.7952 25.8061 11.7003C25.4457 11.334 25.0585 11.1441 24.5245 11.1441C23.4831 11.1441 22.8022 11.9038 22.8022 12.8805C22.8022 13.8573 23.4831 14.6712 24.5645 14.6712C25.0719 14.6712 25.459 14.4813 25.8195 14.115C25.913 14.0201 26.0598 14.0065 26.1666 14.115L26.9677 14.9154C27.0478 14.9968 27.0745 15.1053 26.9944 15.2003Z",
                "M10.8293 27.7151H9.33218C9.20743 27.7151 9.12425 27.6306 9.12425 27.5038V21.0245C9.12425 20.8977 9.20743 20.8132 9.33218 20.8132H10.7738C10.8986 20.8132 10.9817 20.8695 10.9817 21.0386L11.0233 21.771C11.3976 21.1231 12.0075 20.6442 12.9363 20.6442C13.8096 20.6442 14.4888 21.0667 14.8631 21.8696C15.2373 21.1653 15.9027 20.6442 16.9562 20.6442C18.4117 20.6442 19.2989 21.6583 19.2989 23.4613V27.5038C19.2989 27.6306 19.2157 27.7151 19.0909 27.7151H17.5938C17.4691 27.7151 17.3859 27.6306 17.3859 27.5038V23.8838C17.3859 22.9401 17.0532 22.433 16.3047 22.433C15.5839 22.433 15.168 22.9401 15.168 23.8838V27.5038C15.168 27.6306 15.0849 27.7151 14.9601 27.7151H13.4769C13.3383 27.7151 13.2551 27.6306 13.2551 27.5038V23.8838C13.2551 22.9401 12.9085 22.433 12.1739 22.433C11.453 22.433 11.0372 22.9401 11.0372 23.8838V27.5038C11.0372 27.6306 10.954 27.7151 10.8293 27.7151Z",
                "M10.8293 27.7151H9.33218C9.20743 27.7151 9.12425 27.6306 9.12425 27.5038V21.0245C9.12425 20.8977 9.20743 20.8132 9.33218 20.8132H10.7738C10.8986 20.8132 10.9817 20.8695 10.9817 21.0386L11.0233 21.771C11.3976 21.1231 12.0075 20.6442 12.9363 20.6442C13.8096 20.6442 14.4888 21.0667 14.8631 21.8696C15.2373 21.1653 15.9027 20.6442 16.9562 20.6442C18.4117 20.6442 19.2989 21.6583 19.2989 23.4613V27.5038C19.2989 27.6306 19.2157 27.7151 19.0909 27.7151H17.5938C17.4691 27.7151 17.3859 27.6306 17.3859 27.5038V23.8838C17.3859 22.9401 17.0532 22.433 16.3047 22.433C15.5839 22.433 15.168 22.9401 15.168 23.8838V27.5038C15.168 27.6306 15.0849 27.7151 14.9601 27.7151H13.4769C13.3383 27.7151 13.2551 27.6306 13.2551 27.5038V23.8838C13.2551 22.9401 12.9085 22.433 12.1739 22.433C11.453 22.433 11.0372 22.9401 11.0372 23.8838V27.5038C11.0372 27.6306 10.954 27.7151 10.8293 27.7151Z",
                "M10.8293 27.7151H9.33218C9.20743 27.7151 9.12425 27.6306 9.12425 27.5038V21.0245C9.12425 20.8977 9.20743 20.8132 9.33218 20.8132H10.7738C10.8986 20.8132 10.9817 20.8695 10.9817 21.0386L11.0233 21.771C11.3976 21.1231 12.0075 20.6442 12.9363 20.6442C13.8096 20.6442 14.4888 21.0667 14.8631 21.8696C15.2373 21.1653 15.9027 20.6442 16.9562 20.6442C18.4117 20.6442 19.2989 21.6583 19.2989 23.4613V27.5038C19.2989 27.6306 19.2157 27.7151 19.0909 27.7151H17.5938C17.4691 27.7151 17.3859 27.6306 17.3859 27.5038V23.8838C17.3859 22.9401 17.0532 22.433 16.3047 22.433C15.5839 22.433 15.168 22.9401 15.168 23.8838V27.5038C15.168 27.6306 15.0849 27.7151 14.9601 27.7151H13.4769C13.3383 27.7151 13.2551 27.6306 13.2551 27.5038V23.8838C13.2551 22.9401 12.9085 22.433 12.1739 22.433C11.453 22.433 11.0372 22.9401 11.0372 23.8838V27.5038C11.0372 27.6306 10.954 27.7151 10.8293 27.7151Z",
                "M27 27.0108C26.4178 27.6024 25.5445 27.8841 24.588 27.8841C22.3563 27.8841 20.8592 26.3206 20.8592 24.236C20.8592 22.2077 22.2592 20.6442 24.3524 20.6442C26.4178 20.6442 27.6099 22.1936 27.6099 23.9402C27.6099 24.6163 27.4574 24.9966 26.8614 24.9966H22.7305C22.9385 25.8699 23.6454 26.3488 24.7405 26.3488C25.2673 26.3488 25.7663 26.2502 26.3208 25.9262C26.4178 25.8699 26.4871 25.884 26.5564 25.9826L27.0693 26.7009C27.1386 26.7995 27.1247 26.8981 27 27.0108ZM24.3662 22.2499C23.5207 22.2499 22.8692 22.7147 22.7028 23.6303H25.9049C25.794 22.7147 25.1841 22.2499 24.3662 22.2499Z",
                "M27 27.0108C26.4178 27.6024 25.5445 27.8841 24.588 27.8841C22.3563 27.8841 20.8592 26.3206 20.8592 24.236C20.8592 22.2077 22.2592 20.6442 24.3524 20.6442C26.4178 20.6442 27.6099 22.1936 27.6099 23.9402C27.6099 24.6163 27.4574 24.9966 26.8614 24.9966H22.7305C22.9385 25.8699 23.6454 26.3488 24.7405 26.3488C25.2673 26.3488 25.7663 26.2502 26.3208 25.9262C26.4178 25.8699 26.4871 25.884 26.5564 25.9826L27.0693 26.7009C27.1386 26.7995 27.1247 26.8981 27 27.0108ZM24.3662 22.2499C23.5207 22.2499 22.8692 22.7147 22.7028 23.6303H25.9049C25.794 22.7147 25.1841 22.2499 24.3662 22.2499Z",
                "M27 27.0108C26.4178 27.6024 25.5445 27.8841 24.588 27.8841C22.3563 27.8841 20.8592 26.3206 20.8592 24.236C20.8592 22.2077 22.2592 20.6442 24.3524 20.6442C26.4178 20.6442 27.6099 22.1936 27.6099 23.9402C27.6099 24.6163 27.4574 24.9966 26.8614 24.9966H22.7305C22.9385 25.8699 23.6454 26.3488 24.7405 26.3488C25.2673 26.3488 25.7663 26.2502 26.3208 25.9262C26.4178 25.8699 26.4871 25.884 26.5564 25.9826L27.0693 26.7009C27.1386 26.7995 27.1247 26.8981 27 27.0108ZM24.3662 22.2499C23.5207 22.2499 22.8692 22.7147 22.7028 23.6303H25.9049C25.794 22.7147 25.1841 22.2499 24.3662 22.2499Z",
                "M2.36842 12.3158H0V7.57895C0 3.39321 3.39321 0 7.57895 0H12.3158V2.36842H7.57895C4.70125 2.36842 2.36842 4.70125 2.36842 7.57895V12.3158Z",
                "M23.6842 2.36842V0H28.4211C32.6068 0 36 3.39321 36 7.57895V12.3158H33.6316V7.57895C33.6316 4.70125 31.2987 2.36842 28.4211 2.36842L23.6842 2.36842Z",
                "M36 23.6842H33.6316V28.4211C33.6316 31.2987 31.2987 33.6316 28.4211 33.6316H23.6842V36H28.4211C32.6068 36 36 32.6068 36 28.4211V23.6842Z",
                "M12.3158 33.6316V36H7.57895C3.39321 36 0 32.6068 0 28.4211V23.6842H2.36842L2.36842 28.4211C2.36842 31.2987 4.70125 33.6316 7.57895 33.6316H12.3158Z"
            ),
        )

    val security
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val filterfunnel
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M2 4.6C2 4.03995 2 3.75992 2.10899 3.54601C2.20487 3.35785 2.35785 3.20487 2.54601 3.10899C2.75992 3 3.03995 3 3.6 3H20.4C20.9601 3 21.2401 3 21.454 3.10899C21.6422 3.20487 21.7951 3.35785 21.891 3.54601C22 3.75992 22 4.03995 22 4.6V5.26939C22 5.53819 22 5.67259 21.9672 5.79756C21.938 5.90831 21.8901 6.01323 21.8255 6.10776C21.7526 6.21443 21.651 6.30245 21.4479 6.4785L15.0521 12.0215C14.849 12.1975 14.7474 12.2856 14.6745 12.3922C14.6099 12.4868 14.562 12.5917 14.5328 12.7024C14.5 12.8274 14.5 12.9618 14.5 13.2306V18.4584C14.5 18.6539 14.5 18.7517 14.4685 18.8363C14.4406 18.911 14.3953 18.9779 14.3363 19.0315C14.2695 19.0922 14.1787 19.1285 13.9971 19.2012L10.5971 20.5612C10.2296 20.7082 10.0458 20.7817 9.89827 20.751C9.76927 20.7242 9.65605 20.6476 9.58325 20.5377C9.5 20.4122 9.5 20.2142 9.5 19.8184V13.2306C9.5 12.9618 9.5 12.8274 9.46715 12.7024C9.43805 12.5917 9.39014 12.4868 9.32551 12.3922C9.25258 12.2856 9.15102 12.1975 8.94789 12.0215L2.55211 6.4785C2.34898 6.30245 2.24742 6.21443 2.17449 6.10776C2.10986 6.01323 2.06195 5.90831 2.03285 5.79756C2 5.67259 2 5.53819 2 5.26939V4.6Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val captionon
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
                    strokeLineCap = StrokeLineCap.Round,
                    fill = Color.darkPurple
                )
            ),
        )

    val eye
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val menu
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M3 12H21M3 6H21M3 18H15",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val restore
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val close
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M17 7L7 17M7 7L17 17",
                    strokeLineCap = StrokeLineCap.Round
                )
            ),
        )

    val chevrondown
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M6 9L12 15L18 9",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )

    val chevronup
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M18 15L12 9L6 15",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )

    val edit
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M18 9.99982L14 5.99982M2.5 21.4998L5.88437 21.1238C6.29786 21.0778 6.5046 21.0549 6.69785 20.9923C6.86929 20.9368 7.03245 20.8584 7.18289 20.7592C7.35245 20.6474 7.49955 20.5003 7.79373 20.2061L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L3.79373 16.2061C3.49955 16.5003 3.35246 16.6474 3.24064 16.8169C3.14143 16.9674 3.06301 17.1305 3.00751 17.302C2.94496 17.4952 2.92198 17.702 2.87604 18.1155L2.5 21.4998Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )

    val dotsvertical
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
            )
        )

    val dotshorizontal
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
                    strokeLineCap = StrokeLineCap.Round
                ),
            )
        )

    val like
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )
    val likeFilled
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
                    strokeLineCap = StrokeLineCap.Round,
                    fill = Color.darkPurple
                )
            )
        )
    val notifications
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )
    val send
        get() = Icon(
            width = 1.5.rem,
            height = 1.5.rem,
            viewBoxMinX = 0,
            viewBoxMinY = 0,
            viewBoxWidth = 24,
            viewBoxHeight = 24,
            strokePathDatas = listOf(
                StrokePathData(
                    strokeWidth = 2.dp,
                    path = "M10.4995 13.5002L20.9995 3.00017M10.6271 13.8282L13.2552 20.5862C13.4867 21.1816 13.6025 21.4793 13.7693 21.5662C13.9139 21.6415 14.0862 21.6416 14.2308 21.5664C14.3977 21.4797 14.5139 21.1822 14.7461 20.5871L21.3364 3.69937C21.5461 3.16219 21.6509 2.8936 21.5935 2.72197C21.5437 2.57292 21.4268 2.45596 21.2777 2.40616C21.1061 2.34883 20.8375 2.45364 20.3003 2.66327L3.41258 9.25361C2.8175 9.48584 2.51997 9.60195 2.43326 9.76886C2.35809 9.91354 2.35819 10.0858 2.43353 10.2304C2.52043 10.3972 2.81811 10.513 3.41345 10.7445L10.1715 13.3726C10.2923 13.4196 10.3527 13.4431 10.4036 13.4794C10.4487 13.5115 10.4881 13.551 10.5203 13.5961C10.5566 13.647 10.5801 13.7074 10.6271 13.8282Z",
                    strokeLineCap = StrokeLineCap.Round
                )
            )
        )
}


val Icon.Companion.edit
    get() = Icon(
        width = 1.5.rem,
        height = 1.5.rem,
        viewBoxMinX = 0,
        viewBoxMinY = -960,
        viewBoxWidth = 960,
        viewBoxHeight = 960,
        pathDatas = listOf("M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z")
    )

val Icon.Companion.filledNotification
    get() = shared {
        PIcon.notifications.copy(
            width = 0.85.rem,
            height = 0.85.rem,
            strokePathDatas = PIcon.notifications.strokePathDatas.map {
                it.copy(fill = Color.fromInt(selectedThemePrimaryColor()))
            })
    }